import { render, staticRenderFns } from "./warningMessage.vue?vue&type=template&id=4024ade4"
import script from "./warningMessage.vue?vue&type=script&lang=js"
export * from "./warningMessage.vue?vue&type=script&lang=js"
import style0 from "./warningMessage.vue?vue&type=style&index=0&id=4024ade4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports